/** Pilot bounds. Deliberately small and explicit; every one of these has a
 *  matching error code so a caller gets a readable message instead of a crash. */
export const LIMITS = {
    /** Max columns in a dataset schema. */
    maxDatasetColumns: 64,
    /** Max rows accepted in a single snapshot. */
    maxSnapshotRows: 50_000,
    /** Max JSON body / upload size in bytes. */
    maxBodyBytes: 10 * 1024 * 1024,
    /** Max widgets in one report definition. */
    maxWidgetsPerReport: 60,
    /** How many past definition revisions are retained per report. */
    maxRetainedRevisions: 500,
    /** Concurrent headless-Chromium exports. */
    maxConcurrentExports: 2,
    /** Wall-clock budget for a single export. */
    exportTimeoutMs: 60_000,
    /**
     * Rows a table widget prints into a PDF.
     *
     * Page count depends on column count and wrapping, not just rows: the 5-column
     * demo fits ~40 rows a page, while a real 12-column upload with long names
     * wraps to ~19, so 1,000 rows came to 54 pages and rendered in ~2.5s.
     *
     * The print layout flows a table across pages, which is right for a report and
     * wrong for a data dump: a real uploaded dataset of 25,554 rows put ~306,000
     * table cells (~640 pages) into the print surface, and Chromium could not lay
     * that out inside `exportTimeoutMs`, so every PDF export of that report failed.
     * Past this many rows a printed table stops being something a person reads.
     * The full data remains available as a CSV export, and the PDF says so.
     *
     * This caps the *table* only. KPIs and charts on the same page still aggregate
     * every row — capping the data instead would silently make totals wrong.
     */
    maxPrintTableRows: 1_000,
    /** Max characters in a text widget body. */
    maxTextWidgetChars: 5_000,
    /** Max characters in any user/agent supplied label. */
    maxLabelChars: 200,
    /** Max characters in the report subtitle shown under the title. */
    maxSubtitleChars: 200,
    /** Max characters in the "prepared for" line on a report's cover. */
    maxPreparedForChars: 120,
    /** Concurrent file fetches (and their parses) per workspace. */
    maxConcurrentFetchesPerWorkspace: 2,
    /** Concurrent file fetches per server process. */
    maxConcurrentFetches: 8
};
//# sourceMappingURL=limits.js.map